export const ComparePlansData = [
  {
    title: "Base Features",
    subTitle: "All the essentials to get you started with Copilotly.",
    plans: [
      {
        title: "Price (Monthly)",
        free: "FREE",
        optimizer: "$19.00",
        wizard: "$29.00",
        maverick: "$59.00",
      },
      {
        title: "Price (Annual)",
        free: "FREE",
        optimizer: "$14.99/mo",
        wizard: "$24.99/mo",
        maverick: "$54.99/mo",
      },
      {
        title: "Credits Included",
        free: "1,000/month",
        optimizer: "50,000/month",
        wizard: "150,000/month",
        maverick: "500,000/month",
      },
      {
        title: "AI Models",
        free: "GPT-4o Mini",
        optimizer: "GPT-4o, Claude 3.5",
        wizard: "GPT-4o, Claude 3.5, Gemini",
        maverick: "All Models + Priority",
      },
    ],
  },
  {
    title: "AI Copilots",
    subTitle: "Access to expert AI copilots for any task.",
    plans: [
      {
        title: "Quick Copilots",
        free: "5 copilots",
        optimizer: "All 50+ copilots",
        wizard: "All 50+ copilots",
        maverick: "All 50+ copilots",
      },
      {
        title: "Custom Copilots",
        free: "",
        optimizer: "available",
        wizard: "available",
        maverick: "available",
      },
      {
        title: "Copilot Modes",
        free: "Chat only",
        optimizer: "Chat, Craft, Search",
        wizard: "Chat, Craft, Search",
        maverick: "Chat, Craft, Search",
      },
      {
        title: "Document Analysis",
        free: "",
        optimizer: "available",
        wizard: "available",
        maverick: "available",
      },
    ],
  },
  {
    title: "Features",
    subTitle: "Powerful features to boost your productivity.",
    plans: [
      {
        title: "Browser Extension",
        free: "available",
        optimizer: "available",
        wizard: "available",
        maverick: "available",
      },
      {
        title: "Mobile App",
        free: "available",
        optimizer: "available",
        wizard: "available",
        maverick: "available",
      },
      {
        title: "Chat History",
        free: "7 days",
        optimizer: "30 days",
        wizard: "90 days",
        maverick: "Unlimited",
      },
      {
        title: "File Uploads",
        free: "",
        optimizer: "available",
        wizard: "available",
        maverick: "available",
      },
      {
        title: "Voice Input",
        free: "",
        optimizer: "available",
        wizard: "available",
        maverick: "available",
      },
      {
        title: "Export Conversations",
        free: "",
        optimizer: "available",
        wizard: "available",
        maverick: "available",
      },
    ],
  },
  {
    title: "Support",
    subTitle: "Get help when you need it.",
    plans: [
      {
        title: "Community Support",
        free: "available",
        optimizer: "available",
        wizard: "available",
        maverick: "available",
      },
      {
        title: "Email Support",
        free: "",
        optimizer: "available",
        wizard: "available",
        maverick: "available",
      },
      {
        title: "Priority Support",
        free: "",
        optimizer: "",
        wizard: "available",
        maverick: "available",
      },
      {
        title: "Dedicated Account Manager",
        free: "",
        optimizer: "",
        wizard: "",
        maverick: "available",
      },
    ],
  },
];
